import { createAsyncThunk } from '@reduxjs/toolkit';
import { PartnerApiKey } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePartnerApiKey, FindPartnerApiKey } from './interface';

export const findPartnerApiKey = createAsyncThunk(
  'partnerApiKey/findPartnerApiKey',
  async (values: FindPartnerApiKey, { rejectWithValue }) => {
    try {
      return await PartnerApiKey.find({ query: values });
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createPartnerApiKey = createAsyncThunk(
  'partnerApiKey/createPartnerApiKey',
  async (values: CreatePartnerApiKey, { rejectWithValue }) => {
    try {
      return await PartnerApiKey.create(values);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchPartnerApiKey = createAsyncThunk(
  'partnerApiKey/patchPartnerApiKey',
  async (
    { id, isActive }: { id: string; isActive: boolean },
    { rejectWithValue }
  ) => {
    try {
      return await PartnerApiKey.patch(id, { isActive });
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const revokePartnerApiKey = createAsyncThunk(
  'partnerApiKey/revokePartnerApiKey',
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      return await PartnerApiKey.remove(id);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
